import _get from 'lodash-es/get';
import { connect } from 'react-redux';

import AddEmployeeToProgram from './AddEmployeeToProgram';

import { employeeUploadMsg } from '../../../../../common/components/constants';
import {
  setUploadMsg,
  uploadEmployeesClear,
  uploadEmployeesInitiate,
} from '../../../../../../actions/employee';
import { openErrorToast } from '../../../../../../reducers/uiLogic';
import { reviewProgramToEmployeeMappingInitiate } from '../../../../../../actions/programs';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const { programs = {} } = state;
  const { reviewProgramDetails = {} } = programs;
  const programId = reviewProgramDetails.program_id;
  return {
    programId,
    selectedWorkspace,
    uploadMsg: _get(state, 'employees.uploadMsg', employeeUploadMsg),
    uploadingEmployees:
      _get(state, 'apiState.UPLOAD_EMPLOYEES.isFetching', false) &&
      !_get(state, 'apiState.UPLOAD_EMPLOYEES.isIdle', false),
    employeesUploaded: _get(state, 'apiState.UPLOAD_EMPLOYEES.success', false),
    reviewingMapping:
      _get(state, 'apiState.REVIEW_PROGRAM_TO_EMPLOYEE.isFetching', false) &&
      !_get(state, 'apiState.REVIEW_PROGRAM_TO_EMPLOYEE.isIdle', false),
    reviewedMapping: _get(
      state,
      'apiState.REVIEW_PROGRAM_TO_EMPLOYEE.success',
      false,
    ),
    processId: _get(state, 'employees.processId', ''),
  };
};

const mapDispatchToProps = dispatch => ({
  clearUpload: () => dispatch(uploadEmployeesClear()),
  uploadEmployees: payload => dispatch(uploadEmployeesInitiate(payload)),
  setFileUploadMsg: message => dispatch(setUploadMsg(message)),
  showErrorToast: message => dispatch(openErrorToast(message)),
  reviewProgramToEmployeesMapping: payload =>
    dispatch(reviewProgramToEmployeeMappingInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddEmployeeToProgram);
